import { firestore } from '../firebase';


export const getUsers = () => firestore.collection('users').get()
  .then(snapshot => {
    let data = [];
    snapshot.forEach(doc => data.push({ ...doc.data(), id: doc.id }));
    return data;
  });
